<template>
    <div class="view view__lms_superadmin_users_bulk_actions_reactivate_profiles_summary">
        <lms-superadmin-users-bulk-actions-reactivate-profiles-summary></lms-superadmin-users-bulk-actions-reactivate-profiles-summary>
    </div>
</template>

<script>
import { allowRedirectBeforeRouteLeave } from '@/helpers/mixins'
import LmsSuperadminUsersBulkActionsReactivateProfilesSummary from '@/components/lms/superadmin/users/bulk/actions/reactivateprofiles/LmsSuperadminUsersBulkActionsReactivateProfilesSummary'

export default {
  name: 'view-lms-superadmin-users-bulk-actions-reactivate-profiles-summary',
  components: { LmsSuperadminUsersBulkActionsReactivateProfilesSummary },
  mixins: [allowRedirectBeforeRouteLeave]
}
</script>
